<div class="world__cup">
    <div class="world__cup-container">
        <button type="button" class="wrap__thumbnail" (click)="playVideo()" tabindex="0">
            <img [src]="data()?.video_thumbnail" alt="thumbnail" class="thumbnail">
            <img src="assets/icons/play-icon.svg" alt="play-icon" class="play__icon">
            <img [src]="data()?.video_icon" alt="ribbon__logo" class="ribbon__logo">
        </button>
        <div class="wrap__title-desc">
            <p class="title">{{data()?.video_title}}</p>
            <p class="description">{{data()?.video_description}}</p>
        </div>
    </div>
</div>